import React from "react"
import PropTypes from "prop-types"
import PlanAspectButton from "./plan-aspect-button"
import "./plan-aspect.scss"

// Component to show an modifiable aspect of a plan
const PlanAspect = ({
  subText,
  range,
  selectedIndex,
  onIncrement,
  onDecrement
}) => {
  const decrementActive = !(selectedIndex <= 0)
  const incrementActive = !(selectedIndex >= range.length - 1)

  return (
    <div className="plan-aspect">
      <PlanAspectButton
        symbol="-"
        subText={`min ${range[0]}`}
        onClick={onDecrement}
        isActive={decrementActive}
      />
      <div className="plan-aspect--values">
        <div className="plan-aspect--values--main">{range[selectedIndex]}</div>
        <div className="plan-aspect--values--subtext">{subText}</div>
      </div>
      <PlanAspectButton
        symbol="+"
        subText={`max ${range[range.length - 1]}`}
        onClick={onIncrement}
        isActive={incrementActive}
      />
    </div>
  )
}

PlanAspect.propTypes = {
  subText: PropTypes.string.isRequired,
  range: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedIndex: PropTypes.number.isRequired,
  onIncrement: PropTypes.func.isRequired,
  onDecrement: PropTypes.func.isRequired
}

export default PlanAspect
